import { useEffect, useContext, useState } from 'react';

import styles from './TopicsComponent.module.css';

import { GlobalContext } from "../../contexts/globalContext";

import ModeratorVideoComponent from "./ModeratorVideoComponent";
import ConfHeaderComponent from './ConfHeaderComponent';
import TopicComponent from './TopicComponent';

import SeparatorImage from '../../graphics/separator-topic.svg';

const TopicsComponent = () => {

    const {
        selectedProject, currentTopic, currentConference, socketRef, currentModeratorStream, topics, setTopics, setCurrentModeratorStream, participantsStreams, currentParticipantStream,
        currentParticipant
    } = useContext(GlobalContext)
    const [selectedTopic, setSelectedTopic] = useState([]);
    const [showVideo, setShowVideo] = useState(false);
    const [showTopics, setShowTopics] = useState(true);

    useEffect(() => {
        if (currentConference.type === "Meeting") {
            setTopics(selectedProject.topics);
        } else {
            setTopics(currentConference.topics);
        }

        if (currentConference.videoPaused) {
            setShowVideo(false);
        } else {
            setShowVideo(true);
        }

        const playVideosListener = function (conferenceId) {
            if (conferenceId === currentConference._id) {
                setShowVideo(true);
            }
        };

        const pauseVideosListener = function (conferenceId) {
            if (conferenceId === currentConference._id) {
                setShowVideo(false);
            }
        };

        socketRef.current.on('PLAY_VIDEOS', playVideosListener);
        socketRef.current.on('PAUSE_VIDEOS', pauseVideosListener);

        socketRef.current.on('REFRESH_CONFERENCE_TOPICS_FILES', (conferenceId, confTopics) => {
            if (currentConference._id === conferenceId) {
                setTopics(confTopics)
            }
        });


        return () => {
            socketRef.current?.off('PLAY_VIDEOS', playVideosListener);
            socketRef.current?.off('PAUSE_VIDEOS', pauseVideosListener);
        }
    }, [])

    useEffect(() => {
        if (currentConference.videoPaused) {
            setShowVideo(false);
        } else {
            setShowVideo(true);
        }

        if (currentConference.type === "Meeting") {
            setTopics(selectedProject.topics);
        } else {
            setTopics(currentConference.topics);
        }
    }, [currentConference])

    useEffect(() => {
        if (currentConference.type === "Presentation" && participantsStreams && currentParticipantStream) {
            if (currentConference.moderatedBy === currentParticipant?._id) {
                setCurrentModeratorStream({ videoStream: currentParticipantStream, participant: { name: currentParticipant?.name } });
            }

            var currVideo = participantsStreams.find(element => element.participant._id === currentConference.moderatedBy);
            if (currVideo) {
                setCurrentModeratorStream(currVideo);
            }
        }
    }, [participantsStreams, currentParticipantStream])


    return (
        <div className={styles.component} >
            <ConfHeaderComponent setShowTopics={setShowTopics} showTopics={showTopics} />

            {true &&
                <div style={{ height: showTopics ? "calc(100% - 0px)" : "0px", transition: "all 0.5s ease-in-out", display: "flex", flexDirection: "column", alignItems: "center" }}>

                    {currentModeratorStream && showVideo && <ModeratorVideoComponent key={currentModeratorStream.remoteProducerId} />}

                    {(currentConference.type === "Conference" || currentParticipant?._id === currentConference.moderatedBy) && (currentConference.type !== "Meeting") &&
                        <div className={styles.topicsCanvas} >
                            {topics?.map((topic, index) => (<div style={{ position: "relative" }} key={topic._id}>
                                {index === 0 && <img src={SeparatorImage} width={900} style={{ marginTop: "-15px", position: "absolute" }} />}
                                <TopicComponent key={topic._id} topic={topic} index={index + 1} selectedTopic={selectedTopic} setSelectedTopic={setSelectedTopic} topicsLength={topics.length} />
                                <img src={SeparatorImage} width={900} style={{ marginTop: "-15px", position: "absolute" }} />
                            </div>))}
                        </div>
                    }

                    {(currentConference.type === "Meeting") &&
                        <div className={styles.topicsCanvas} >
                            {topics?.map((topic, index) =>
                            (<div style={{ position: "relative" }} key={topic._id}>
                                {index === 0 && <img src={SeparatorImage} width={900} style={{ marginTop: "-15px", position: "absolute" }} />}
                                <TopicComponent key={topic?._id || index} topic={topic} index={index + 1} selectedTopic={selectedTopic} setSelectedTopic={setSelectedTopic} topicsLength={topics.length} />
                                <img src={SeparatorImage} width={900} style={{ marginTop: "-15px", position: "absolute" }} />
                            </div>))}
                            <img src={SeparatorImage} width={900} style={{ marginTop: "-30px" }} />
                        </div>
                    }

                    {currentConference.type === "Presentation" && currentConference.moderatedBy !== currentParticipant?._id && showVideo &&
                        <div className={styles.rest}>
                            {currentTopic && <>
                                <div className={styles.title}>Current Topic</div>
                                <div className={styles.name}>{currentTopic?.name}</div>
                            </>}
                        </div>
                    }
                </div>
            }
        </div>
    );
}

export default TopicsComponent;